import React from "react";
import { styled } from "@mui/material/styles";
import {
  Container,
  Typography,
  Grid,
  Box,
  CircularProgress,
  Link,
  Autocomplete,
  TextField,
  Stack,
} from "@mui/material";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import ImageBackround from "../sliders/image-backround";

const MyAutocomplete = styled(Autocomplete)(({ theme }) => ({
  color: "#fff",
  [`& .${autocompleteClasses.popupIndicator}`]: {
    transform: "none",
  },
  "& .MuiFormControl-root": {
    "& .MuiFormLabel-root": {
      color: "#fff",
      fontSize: "18px",
      fontFamily: "Poppins-Regular",
    },
    "& .MuiInputBase-root": {
      borderColor: "#fff",
      color: "#fff",
    },
    "& .MuiInputBase-root:after": {
      display: "none",
    },

    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
      color: "#fff",
      visibility: "visible",
    },
  },
}));

export default function Locations(props) {
  const { component } = props;
  const devHelper = component.getHelpers("dev");

  const country = component.getCountry();
  const {
    locations = [],
    stores = [],
    states = [],
    store = null,
    state = null,
  } = component.getData("default", {});

  const changeState = (newValue) => {
    component.setData({ "default.state": newValue });
    component.setLocations();
  };

  const changeStore = (newValue) => {
    component.setData({ "default.store": newValue });
    component.setLocations();
  };

  return (
    <Container
      sx={{
        px: 4,
        minHeight: "100vh",
      }}
      disableGutters
      maxWidth="xl"
    >
      <ImageBackround
        {...{
          ...props,
          ...{
            slide: {
              title: "locations",
              slug: "locations-background",
              imagesPath: "/marketing/background",
            },
          },
        }}
      />
      <Box sx={{ textAlign: "center", mt: "150px" }}>
        <Typography
          sx={{
            fontSize: "26px",
            fontFamily: "Poppins-Regular",
            color: "#fff",
            textTransform: "uppercase",
          }}
        >
          {component.trans(country)}
        </Typography>
      </Box>
      <Grid
        container
        sx={{
          alignItems: "center",
          mt: 3,
        }}
        direction="row"
        rowSpacing={1}
        columnSpacing={{ xs: 0, sm: "4px" }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          justifycontent="center"
          sx={{
            textAlign: "center",
          }}
        >
          <MyAutocomplete
            value={state}
            onChange={(event, newValue) => {
              changeState(newValue);
            }}
            options={states}
            popupIcon={
              <i
                className="fa-solid fa-location-dot"
                style={{ color: "#fff", fontSize: "22px" }}
              />
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="FIND BY LOCATION"
                variant="standard"
                sx={{
                  m: 1,
                  maxWidth: "200px",
                  "& .MuiFormLabel-root": {
                    fontSize: 18,
                    fontFamily: "Poppins-Bold !important",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          justifycontent="center"
          sx={{
            textAlign: "center",
          }}
        >
          <MyAutocomplete
            value={store}
            onChange={(event, newValue) => {
              changeStore(newValue);
            }}
            options={stores}
            popupIcon={
              <i
                className="fa-solid fa-shop"
                style={{ color: "#fff", fontSize: "22px" }}
              />
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="FIND BY STORE"
                variant="standard"
                sx={{
                  m: 1,
                  maxWidth: "176px",
                  "& .MuiFormLabel-root": {
                    fontSize: 18,
                    fontFamily: "Poppins-Bold !important",
                  },
                }}
              />
            )}
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          width: "100%",
          my: 3,
          borderBottom: "1px solid #fff",
          borderTop: "1px solid #fff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "142.69px",
        }}
      >
        {!locations ? (
          <CircularProgress
            sx={{
              color: "#fff",
            }}
          />
        ) : (
          <>
            {locations.length !== 0 ? (
              <Grid
                container
                sx={{
                  flexGrow: 1,
                  alignItems: "stretch",
                  m: 0,
                  py: 3,
                }}
                direction="row"
                rowSpacing={2}
                columnSpacing={1}
              >
                {locations.map((loc, index) => {
                  const {
                    slug,
                    name,
                    address_text_1 = null,
                    address_text_2 = null,
                    url = null,
                    phone = "",
                    email = null,
                    email_text = null,
                  } = devHelper.getObjectValue(loc, "_values");

                  var new_phone = "",
                    number = "",
                    country_num = "";

                  if (phone.trim().length >= 10) {
                    number = phone.slice(-10);
                    country_num = phone.slice(0, -10);
                    new_phone =
                      (country_num && country_num + "-") +
                      number.slice(0, 3) +
                      "-" +
                      number.slice(3, 6) +
                      "-" +
                      number.slice(-4);
                  }

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      justifycontent="center"
                      sx={{
                        textAlign: "center",
                        pb: 2,
                      }}
                      key={"location-" + slug}
                    >
                      <Stack spacing={1}>
                        <Typography
                          sx={{
                            fontFamily: "Poppins-Bold",
                            color: "#fff",
                            fontSize: 20,
                            lineHeight: 1.2,
                          }}
                        >
                          {name}
                        </Typography>
                        <Stack>
                          {url && address_text_1 && (
                            <Link
                              href={url}
                              rel="noreferrer"
                              target="_blank"
                              underline="none"
                              sx={{
                                fontFamily: "Spartan-SemiBold",
                                color: "#fff",
                                fontSize: 14,
                                lineHeight: 1.2,
                              }}
                            >
                              {address_text_1 && address_text_1}
                            </Link>
                          )}
                          {url && address_text_2 && (
                            <Link
                              href={url}
                              rel="noreferrer"
                              target="_blank"
                              underline="none"
                              sx={{
                                fontFamily: "Spartan-SemiBold",
                                color: "#fff",
                                fontSize: 14,
                                lineHeight: 1.2,
                              }}
                            >
                              {address_text_2 && address_text_2}
                            </Link>
                          )}
                        </Stack>
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                            "& *": {
                              fontFamily: "Spartan-SemiBold",
                              color: "#fff",
                              fontSize: 14,
                              lineHeight: 1.2,
                            },
                            "& a": {
                              color: "#fff",
                            },
                          }}
                        >
                          {phone && (
                            <>
                              <Box component="span">Tel:</Box>
                              <Link href={"tel:" + phone} underline="none">
                                {new_phone}
                              </Link>
                            </>
                          )}
                          {email && (
                            <>
                              <Box component="span">Email:</Box>
                              <Link
                                href={"mailto:" + email}
                                target="_blank"
                                underline="none"
                              >
                                {email_text}
                              </Link>
                            </>
                          )}
                        </Stack>
                      </Stack>
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <Box
                sx={{
                  textAlign: "center",
                }}
              >
                <Typography sx={{ color: "#fff" }}>
                  NO LOCATIONS FOUND
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>
    </Container>
  );
}
